module.exports = __webpack_public_path__ + "img/circularityScore2.e37e97c3.jpg";